const desktop = {
  sourceWidth: 1920,
  aspectRatio: 1440 / 690,
  breakpoints: [1280, 1440, 1680, 1920],
  backgroundColor: '#EDEDED',
  layout: 'fullWidth',
  options: {
    fitIn: true,
  },
}

const mobile = {
  sourceWidth: 768,
  aspectRatio: 480 / 317,
  breakpoints: [768],
  backgroundColor: '#EDEDED',
  layout: 'fullWidth',
  options: {
    fitIn: true,
  },
}

module.exports = {
  'doubleBanner.desktop': {
    sourceWidth: 1920,
    aspectRatio: 16 / 5,
    backgroundColor: '#EDED',
    breakpoints: [1280, 1440, 1680, 1920],
    layout: 'fullWidth',
    options: {
      fitIn: true,
    },
  },
  'doubleBanner.mobile': {
    sourceWidth: 1920,
    aspectRatio: 19 / 20,
    backgroundColor: '#EDED',
    breakpoints: [375, 425, 768],
    layout: 'fullWidth',
    options: {
      fitIn: true,
    },
  },
  'carousel.desktop': {
    sourceWidth: 1920,
    aspectRatio: 1440 / 690,
    breakpoints: [1920],
    backgroundColor: '#EDEDED',
    layout: 'fullWidth',
    options: {
      fitIn: true,
    },
  },
  'carousel.mobile': {
    sourceWidth: 768,
    aspectRatio: 16 / 15,
    breakpoints: [768],
    backgroundColor: '#EDEDED',
    layout: 'fullWidth',
    options: {
      fitIn: true,
    },
  },
  'narrowBannerCarousel.desktop': {
    sourceWidth: 1920,
    aspectRatio: 1440 / 690,
    breakpoints: [1920],
    backgroundColor: '#EDEDED',
    layout: 'constrained',
    options: {
      fitIn: true,
    },
  },
  'narrowBannerCarousel.mobile': {
    sourceWidth: 768,
    aspectRatio: 16 / 15,
    breakpoints: [768],
    backgroundColor: '#EDEDED',
    layout: 'constrained',
    options: {
      fitIn: true,
    },
  },
  'fullwidthCarousel.desktop': {
    sourceWidth: 1920,
    aspectRatio: 15 / 4,
    breakpoints: [1920],
    backgroundColor: '#EDEDED',
    layout: 'fullWidth',
    options: {
      fitIn: true,
    },
  },
  'fullwidthCarousel.mobile': {
    sourceWidth: 768,
    aspectRatio: 15 / 16,
    breakpoints: [768],
    backgroundColor: '#EDEDED',
    layout: 'fullWidth',
    options: {
      fitIn: true,
    },
  },
  'staticBanner.desktop': desktop,
  'staticBanner.mobile': mobile,
  'fullwidthBanner.desktop': {
    sourceWidth: 1920,
    aspectRatio: 8 / 3,
    breakpoints: [1280, 1440, 1680, 1920],
    backgroundColor: '#FFFFFF',
    layout: 'fullWidth',
    options: {
      fitIn: true,
    },
  },
  'fullwidthBanner.mobile': {
    sourceWidth: 750,
    aspectRatio: 25 / 32,
    breakpoints: [375, 425, 768],
    backgroundColor: '#FFFFFF',
    layout: 'fullWidth',
    options: {
      fitIn: true,
    },
  },
  'showcaseBanner.desktop': desktop,
  'showcaseBanner.mobile': mobile,
  'product.summary': {
    sourceWidth: 480,
    aspectRatio: 1,
    width: 360,
    breakpoints: [250, 360, 480],
    layout: 'constrained',
    fadeIn: false,
    backgroundColor: '#f0f0f0',
    options: {
      fitIn: true,
    },
  },
  'mosaicGridCollection1x1.desktop': {
    sourceWidth: 600,
    aspectRatio: 1,
    width: 409,
    breakpoints: [768],
    layout: 'constrained',
    fadeIn: false,
    backgroundColor: '#f0f0f0',
    options: {
      fitIn: true,
    },
  },
  'mosaicGridCollection1x2.desktop': {
    sourceWidth: 1216,
    width: 1216,
    height: 600,
    breakpoints: [768],
    layout: 'constrained',
    fadeIn: false,
    backgroundColor: '#f0f0f0',
    options: {
      fitIn: true,
    },
  },
  'mosaicGridCollection1x1.mobile': {
    sourceWidth: 600,
    aspectRatio: 1,
    width: 300,
    breakpoints: [768],
    layout: 'constrained',
    fadeIn: false,
    backgroundColor: '#f0f0f0',
    options: {
      fitIn: true,
    },
  },
  'mosaicGridCollection1x2.mobile': {
    sourceWidth: 608,
    aspectRatio: 1,
    width: 608,
    height: 300,
    breakpoints: [768],
    layout: 'constrained',
    fadeIn: false,
    backgroundColor: '#f0f0f0',
    options: {
      fitIn: true,
    },
  },
  'product.details': {
    sourceWidth: 720,
    aspectRatio: 1,
    width: 720,
    breakpoints: [250, 360, 480, 720],
    layout: 'constrained',
    backgroundColor: '#f0f0f0',
    options: {
      fitIn: true,
    },
  },
  'product.miniature': {
    sourceWidth: 720,
    aspectRatio: 1,
    width: 100,
    breakpoints: [50, 100, 150],
    layout: 'constrained',
    backgroundColor: '#f0f0f0',
    options: {
      fitIn: true,
    },
  },
  'five.media.main': {
    sourceWidth: 1920,
    aspectRatio: 172 / 263,
    breakpoints: [750],
    layout: 'constrained',
    backgroundColor: '#f0f0f0',
    options: {
      fitIn: true,
    },
  },
  'five.media.secondary': {
    sourceWidth: 1920,
    aspectRatio: 73 / 100,
    breakpoints: [260, 360, 750, 1024, 1440, 1920],
    layout: 'constrained',
    backgroundColor: '#f0f0f0',
    options: {
      fitIn: true,
    },
  },
  'three.media.main': {
    sourceWidth: 1920,
    aspectRatio: 421 / 562,
    breakpoints: [750],
    layout: 'constrained',
    backgroundColor: '#f0f0f0',
    options: {
      fitIn: true,
    },
  },
  'three.media.secondary': {
    sourceWidth: 1920,
    aspectRatio: 256 / 281,
    breakpoints: [260, 360, 750, 1024, 1440, 1920],
    layout: 'constrained',
    backgroundColor: '#f0f0f0',
    options: {
      fitIn: true,
    },
  },
}
